import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';
import get from 'lodash/get';
import { fetchPageDataFactory } from 'actions/pageActionsV4';
export var exchangeTermsActions;
(function (exchangeTermsActions) {
    exchangeTermsActions["REQUEST"] = "GET_EXCHANGE_TERMS_REQUEST";
    exchangeTermsActions["SUCCESS"] = "GET_EXCHANGE_TERMS_SUCCESS";
    exchangeTermsActions["ERROR"] = "GET_EXCHANGE_TERMS_ERROR";
})(exchangeTermsActions || (exchangeTermsActions = {}));
export function getExchangeTermsInfoSuccess(exchangeTerms) {
    return {
        type: exchangeTermsActions.SUCCESS,
        data: exchangeTerms
    };
}
export function getExchangeTermsInfo(params) {
    return (dispatch) => {
        dispatch({
            type: exchangeTermsActions.REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/1/guide/exchangeTermsAndInfo',
            action: exchangeTermsActions.REQUEST
        }), params).then(data => dispatch({
            type: exchangeTermsActions.SUCCESS,
            data: get(data, 'RESPONSE.howExchangeWorks')
        }), error => {
            dispatch({
                type: exchangeTermsActions.ERROR,
                error
            });
            return Promise.reject(error);
        });
    };
}
/************************************  Verify IMEI Actions  ************************************/
export var verifyIMEIActions;
(function (verifyIMEIActions) {
    verifyIMEIActions["REQUEST"] = "VERIFY_IMEI_REQUEST";
    verifyIMEIActions["SUCCESS"] = "VERIFY_IMEI_SUCCESS";
    verifyIMEIActions["ERROR"] = "VERIFY_IMEI_ERROR";
    verifyIMEIActions["RESET"] = "RESET_IMEI_REQUEST";
})(verifyIMEIActions || (verifyIMEIActions = {}));
export function resetIMEIDataAction() {
    return {
        type: verifyIMEIActions.RESET
    };
}
export function verifyIMEIAction(params) {
    return (dispatch) => {
        dispatch({
            type: verifyIMEIActions.REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: `/api/4/imei/${params.validateMap.imei}?lid=${params.listingId}&pid=${params.productId}`,
            action: verifyIMEIActions.REQUEST
        }), params).then(data => dispatch({
            type: verifyIMEIActions.SUCCESS,
            data: data['RESPONSE']
        }), err => {
            dispatch({
                type: verifyIMEIActions.ERROR,
                error: err
            });
            return Promise.reject(err);
        });
    };
}
/****************************** Exchange Tooltip V4 Actions  ******************************/
export var EXCHANGE_TOOLTIP_ACTIONS;
(function (EXCHANGE_TOOLTIP_ACTIONS) {
    EXCHANGE_TOOLTIP_ACTIONS["REQUEST"] = "EXCHANGE_TOOLTIP_REQUEST";
    EXCHANGE_TOOLTIP_ACTIONS["SUCCESS"] = "EXCHANGE_TOOLTIP_SUCCESS";
    EXCHANGE_TOOLTIP_ACTIONS["ERROR"] = "EXCHANGE_TOOLTIP_ERROR";
    EXCHANGE_TOOLTIP_ACTIONS["CLEAR"] = "EXCHANGE_TOOLTIP_CLEAR";
})(EXCHANGE_TOOLTIP_ACTIONS || (EXCHANGE_TOOLTIP_ACTIONS = {}));
export const fetchExchangeTooltipData = fetchPageDataFactory(EXCHANGE_TOOLTIP_ACTIONS.REQUEST, EXCHANGE_TOOLTIP_ACTIONS.SUCCESS, EXCHANGE_TOOLTIP_ACTIONS.ERROR);
export function clearTooltipData() {
    return {
        type: EXCHANGE_TOOLTIP_ACTIONS.CLEAR
    };
}
